module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms1_m_jp.858d098ef1141a16fa235f839034f857.png";